import { Text, Form, TextInput, InputLabel, Button } from '@design-system/';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { change_password, get_profile_details } from './redux/reducer';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

const Container = styled.div`
  background-color: #fff;
  border: 0.5px solid #e0e0e0;
  border-radius: 4px;
  margin-top: 26px;

  .main {
    padding: 22px 15px;
    border-bottom: 1px solid #e0e0e0;
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    margin: 0;
  }

  .form {
    padding: 22px 15px;
  }

  ${mediaQuery.desktop`
  background-color: #fff;
  border: 0.5px solid #E0E0E0;
  border-radius: 4px;
  margin-top: 26px;

  .main {
    padding: 24px 22px;
    border-bottom: 1px solid #E0E0E0;
    font-size: 18px;
    font-weight: 700;
    color: #333333;
    margin: 0;
  }

  .form {
    padding: 24px 22px;
  }
`}
`;

const Footer = styled.div`
  ${mediaQuery.desktop`
display: flex;
justify-content: space-between;
margin-top: 1em;
`}
  display: block;
  margin-top: 1em;
`;

const Password = () => {
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false);

  useEffect(() => {
    dispatch(get_profile_details());
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      new_password: '',
      confirm_password: '',
      old_password: '',
    },
    onSubmit: async (data) => {
      dispatch(change_password(data));
      setLoad(true);
    },

    validationSchema: Yup.object({
      new_password: Yup.string().required('Password is required.'),
      confirm_password: Yup.string().oneOf(
        [Yup.ref('new_password'), null],
        'Passwords must match',
      ),
      old_password: Yup.string().required('Current password is required.'),
    }),
  });
  return (
    <>
      <Container>
        <div className="main">Password</div>

        <Form onSubmit={formik.handleSubmit} className="form">
          <InputLabel htmlFor="current">Currrent password</InputLabel>
          <TextInput
            name="old_password"
            type="password"
            id="old_password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.old_password}
          ></TextInput>
          {formik.touched.old_password && formik.errors.old_password ? (
            <Text color="red" align="left">
              {formik.errors.old_password}
            </Text>
          ) : null}
          <InputLabel htmlFor="current">New password</InputLabel>
          <TextInput
            name="new_password"
            type="password"
            id="password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.new_password}
          ></TextInput>
          {formik.touched.new_password && formik.errors.new_password ? (
            <Text color="red" align="left">
              {formik.errors.new_password}
            </Text>
          ) : null}

          <InputLabel htmlFor="current">Confirm new password</InputLabel>
          <TextInput
            name="confirm_password"
            type="password"
            id="confirm-password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirm_password}
          ></TextInput>
          {formik.touched.confirm_password && formik.errors.confirm_password ? (
            <Text color="red" align="left">
              {formik.errors.confirm_password}
            </Text>
          ) : null}
          <Footer>
            <Button
              text={load ? 'Saving...' : 'Save Changes'}
              align="center"
              bgColor="#549A9A"
              type="submit"
              width="100%"
            />
          </Footer>
        </Form>
      </Container>
    </>
  );
};

export default Password;
